// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__9lNVg","container__content":"styles_container__content__Jdy6f","skeleton-animation":"styles_skeleton-animation__VhNRS"};